import { Action } from 'redux';
import { ContractBranchState, ContractBranchUnloadState } from '../../states/ContractBranchState';

export default function ContractBranchesGetAllReducer(
  state: ContractBranchState | undefined,
  action: Action
): ContractBranchState {
  const currentState = state ?? ContractBranchUnloadState;
  const a: any = action;

  switch (a.type) {
    case 'CONTRACTBRANCH_GET_ALL_BY_CONTRACTID_REQUEST_ACTION':
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_REQUEST_ACTION':
    case 'CONTRACTBRANCH_UPDATE_ALL_BY_CONTRACTID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
      };

    case 'CONTRACTBRANCH_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION':
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_RECEIVE_ACTION':
    case 'CONTRACTBRANCH_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: a.contractBranches || [],
      };

    case 'CONTRACTBRANCH_GET_ALL_BY_CONTRACTID_ERROR_ACTION':
    case 'CONTRACTBRANCH_GET_ALL_BY_ADDENDUMID_ERROR_ACTION':
    case 'CONTRACTBRANCH_UPDATE_ALL_BY_CONTRACTID_ERROR_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error,
      };

    default:
      return currentState;
  }
}
